<div *ngIf="meta" class="poc-tier-bar" [attr.title]="meta.tooltip" role="status" aria-live="polite">
  <span class="poc-tier-bar__pill">{{ meta.label }}</span>
  <a
    *ngIf="meta.nudgeLink; else nudgeText"
    [routerLink]="meta.nudgeLink"
    class="poc-tier-bar__nudge poc-tier-bar__nudge--link"
  >
    {{ meta.nudge }}
  </a>
  <ng-template #nudgeText>
    <span class="poc-tier-bar__nudge">{{ meta.nudge }}</span>
  </ng-template>
</div>
